(() => {
  const savedContent = new Map();
  function placeLatest() {
    const source = document.querySelector('[data-fos-editorial-source]');
    const target = document.querySelector('[data-fos-latest-target]');
    if (!source || !target) return;
    const content = source.querySelector('[data-fos-latest-content]') || savedContent.get(source.dataset.fosEditorialSource);
    if (!content) return;
    savedContent.set(source.dataset.fosEditorialSource, content);
    const oldContent = target.querySelector('[data-fos-latest-content]');
    if (oldContent && oldContent !== content) oldContent.remove();
    for (const name of [...target.classList]) {
      if (name.startsWith('section-')) target.classList.remove(name);
    }
    target.classList.add(`section-${source.dataset.fosEditorialSource}`);
    target.querySelector('.fos-editorial-destination__inner').append(content);
    target.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeLatest);
  else placeLatest();
  document.addEventListener('shopify:section:load', placeLatest);
  document.addEventListener('shopify:section:reorder', placeLatest);
})();
